import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Alert, AlertTitle } from '@mui/material';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  // accessibleRoles: PropTypes.array, // Example ['admin', 'leader']
  allowAll: PropTypes.bool,
  children: PropTypes.node
};

export default function RoleBasedGuard({ children, pageId = 'none', allowAll = false }) {
  const [allowedPages, setAllowedPages] = useState([]);
  const { actualRol } = useSelector((state) => state.dagpacketRoles);

  // console.log('rol actual', actualRol);

  useEffect(() => {
    const pages = [];
    actualRol?.sectionViews?.map((section) => {
      section?.allowedViews?.map((view) => {
        if (view.allowedPage) {
          pages.push(view.id);
        }

        return false;
      });

      return false;
    });

    // console.log(pages);
    setAllowedPages(pages);
  }, [actualRol]);

  // if (accessibleRoles.includes(userTypeId) || allowAll) {
  //   return <>{children}</>;
  // }
  if (allowedPages?.includes(pageId) || allowAll) {
    return <>{children}</>;
  }
  // if (allowAll) {
  //   return <>{children}</>;
  // }

  return (
    <Container>
      <Alert severity="error">
        <AlertTitle>Permission Denied</AlertTitle>
        You do not have permission to access this page
      </Alert>
    </Container>
  );
}
